import React from 'react';
import PropTypes from "prop-types";
import {convertirModena, formatFecha} from "../../shared/utils/utils";
import './style.scss'

export const PagoDeduccion = ({datapago, prestaciones}) => {
    let compensacion = (datapago.length > 0 ? datapago[0].compesacionTipo : []);
    let dataCenta = (datapago.length > 0 ? datapago[0].cuenta : []);
    let datainfoRep = (datapago.length > 0 ? datapago[0] : []);


    function arrayToatels(fields){
        let total = 0;
        if (fields.length > 0) {
            for (const pago of fields) {
                total += parseInt(pago[1])
            }

        }

        return total;
    }

    /*function sumaPrestacion(fields) {
        let comarra = [];
        for (const refElement of fields) {
            comarra = [...comarra, ...refElement['prestaciones']]
        }

        const groups = new Set(comarra.map(item => item.descripcion.trim().toUpperCase()));

        let obje = {};
        groups.forEach(g => {
            obje[g] = [];
            for (const el of comarra) {

                if (g === el.descripcion.trim().toUpperCase()) {
                    obje[g] = [...obje[g], el]
                }
            }
        })

        let objeSuma = {};
        for (const refKey in obje) {
            objeSuma[refKey] = 0;

            for (const refElement of obje[refKey]) {

                if (refElement.descripcion.trim().toUpperCase() === refKey) {

                    objeSuma[refKey] += refElement['valor']
                }
            }

        }
        return Object.keys(objeSuma).map(function (key) {
            return [key, objeSuma[key]];
        });
    }*/

    function sumaCompensacion(fields) {
        let comarra = [];
        for (const refElement of fields) {
            comarra = [...comarra, ...refElement['compesacionTipo']]
        }
        const groups = new Set(comarra.map(item => item.descripcion));

        let obje = {};
        groups.forEach(g => {
            obje[g] = [];
            for (const el of comarra) {
                if (g === el.descripcion) {
                    obje[g] = [...obje[g], el]
                }
            }
        })
        let objeSuma = {};
        for (const refKey in obje) {
            objeSuma[refKey] = 0;

            for (const refElement of obje[refKey]) {

                if (refElement.descripcion === refKey) {
                    objeSuma[refKey] += refElement['valor']
                }
            }

        }
        return Object.keys(objeSuma).map(function (key) {
            return [key, objeSuma[key]];
        });
    }

    function juntarDeducciones(fields){
        let deducciones = []
        if (fields.length > 0) {
            deducciones = [...deducciones, ...fields[0].deducciones]
        }
     return deducciones;
    }

    function totalDeducciones(fields){
        let deducciones = []
        let total = 0;
        if (fields.length > 0) {
            deducciones = [...deducciones, ...fields[0].deducciones]
        }

        if (deducciones.length > 0) {
            for (const deduccione of deducciones) {

                total += Math.round(deduccione.valor)
            }
        }
        return total;
    }

    function sumaIngreso(fields) {
        let suma = 0;
        for (const field of fields) {
            suma += parseFloat(field['sub_total']);
        }
        if (prestaciones.length > 0) {
            for (const fieldElement of prestaciones) {
                suma += parseFloat(fieldElement.valor);
            }
        }
        return Math.round(suma);
    }

    const totalesCom =  sumaCompensacion(datapago);
    //const totalPres = sumaPrestacion(datapago);
    const totalCompensacion = arrayToatels(totalesCom)

    //const arrayTotales = arrayToatels(datapago);

    const ingreso = sumaIngreso(datapago);
   const deducciones = juntarDeducciones(datapago);

   const totalDed = totalDeducciones(datapago);


    // const initialValue = 0;

  /*  const SumaTotales  = arrayTotales.reduce(
        (previousValue, currentValue) => previousValue + currentValue,
        initialValue
    );*/


    return (
        <div className="container px-10 pagoDeduccion">
            <div className="header-cont hidden" style={{width: "100%"}}>
                <h1 style={{marginLeft:"25%",fontSize:"20pt",}}>COMPENSACIÓN</h1>
                <img alt={"toa"} src="/img/toa.png" style={{marginTop:"10px", height:"auto", width:"10%"}}/>
            </div>

            {/*cabezera*/}
            <div className='row info py-2 my-1'>
                <div className=" mt-2 info-text lg:w-3/12 px-4">
                    <span className="font-semibold mr-2"> Cédula: </span> <span className="text-xs name">{dataCenta.num_doc}</span>
                </div>
                <div className=" mt-2 info-text lg:w-6/12 px-4">
                    <span className="font-semibold mr-2"> Nombre: </span> <span className="text-xs name"> {dataCenta.nombre}</span>
                </div>
                <div className=" mt-2 info-text lg:w-3/12 px-4">
                    <span className="font-semibold mr-2"> Fecha pago: </span> <span className="text-xs name"> {formatFecha(datainfoRep.fecha)}</span>
                </div>
            </div>
            {/*compensaciones*/}

            <table className="items-center w-full bg-transparent border-collapse">
                <thead>
                <tr>
                    <th
                        className={
                            "px-6 texto-margin align-middle  border-gray-500 border-solid  py-3 text-xs uppercase  whitespace-nowrap font-semibold text-center   "

                        }
                    >
                        Periodo
                    </th>
                    <th
                        className={
                            "lg:w-4/12 px-6 texto-margin align-middle border-gray-500 border-solid  py-3 text-xs uppercase whitespace-nowrap font-semibold text-center   "

                        }
                    >
                        Institución
                    </th>

                    {(compensacion.length > 0) && compensacion.map(((data, i) => <th
                        className={
                            "px-6 texto-margin align-middle border-gray-500 border-solid  py-3 text-xs uppercase whitespace-nowrap font-semibold text-center"

                        }
                        key={i}>{data['descrip_abrev']}</th>))}
                    <th
                        className={
                            "px-6 align-middle border-gray-500 border-solid  py-3 text-xs uppercase whitespace-nowrap font-semibold text-center"

                        }
                    >
                        Total
                    </th>


                </tr>
                </thead>
                <tbody>
                {(datapago.length > 0) && datapago.map((info, i) => {

                    return <tr key={i}>
                        <td className="border-t-0 border-gray-500 border-solid px-6 texto-margin align-middle  text-xs whitespace-nowrap p-4 text-left items-center">
                                <span className="ml-3 font-bold text-blueGray-600">
                                  {`${info.anio}/ ${info.mes} / P.${info.periodo}`}
                                </span>
                        </td>
                        <td className="border-t-0 border-gray-500 border-solid px-6 texto-margin align-middle  text-xs whitespace-nowrap p-4 text-left items-center">
                                <span className="ml-3 font-bold text-blueGray-600">
                                  {info.nombre}
                                </span>
                        </td>

                        {(info['compesacionTipo'].length > 0) && info['compesacionTipo'].map(((data, i) => <td
                            className="border-t-0 border-gray-500 border-solid px-4 align-middle  text-xs whitespace-nowrap p-4 text-right items-center"
                            key={i}><span
                            className="ml-4 font-bold text-blueGray-600">{convertirModena(data['valor'])} </span>
                        </td>))}

                        <td
                            className="border-t-0 border-gray-500 border-solid px-4 align-middle  text-xs whitespace-nowrap p-4 text-right items-center"
                            key={i}><span
                            className="ml-4 font-bold text-blueGray-600">{convertirModena(info.totalCompensacion)} </span>
                        </td>
                    </tr>


                })}

                </tbody>
                <tfoot>
                <tr>
                    <td className="px-5 total align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">TOTAL</td>
                    <td className="px-5 total-partner align-middle border-gray-500 border-solid  py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"></td>

                   {totalesCom.length > 0 && totalesCom.map(((data, i) => <td
                        className="px-5 total-num align-middle border-gray-500 border-solid  py-3 text-xs uppercase whitespace-nowrap font-semibold text-right "
                        key={i}>{convertirModena(data[1])}
                    </td>))}
                  {  <td
                      className="px-5 total-num align-middle border-gray-500 border-solid  py-3 text-xs uppercase whitespace-nowrap font-semibold text-right "
                       >{convertirModena(totalCompensacion)}
                    </td>}
                </tr>
                </tfoot>
            </table>
            {/*prestaciones*/}



            <div className='row'>
                <div className="mt-2 lg:w-7/12">
                    <table className="items-center w-full bg-transparent border-collapse">
                        <tbody>
                        {prestaciones.length > 0 && prestaciones.map((com, i) =>
                            <tr  key={i}>
                                <td   className={
                                    "px-6 texto-margin align-middle   py-3 text-xs uppercase  whitespace-nowrap font-semibold text-left   "

                                }>{com.descripcion}:</td>
                                <td  className={
                                    "px-6 texto-margin align-middle  py-3 text-xs uppercase  whitespace-nowrap font-semibold text-left   "

                                }>{convertirModena(com.valor)}</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="table-container">
                <div className="row">
                    <div className="totales" style={{marginLeft: "60%", marginTop: "15px" }} >
                        <ol type={"A"}>
                            <li>
                                <p>
                                    <span className=" uppercase font-semibold text-lg"> Total ingresos: </span> <span className="ml-2 font-semibold text-md">  {convertirModena(ingreso)} </span>
                                </p>
                            </li>
                        </ol>
                    </div>
                </div>

                {/*deducciones*/}

                <div className="mt-5 mb-4 row justify-center py-3 border-gray-500 border-gray-500  border-solid font-semibold">
                    <h2 className="capitalize deduccion">DEDUCCIONES</h2>
                </div>

                <table className="items-center w-full bg-transparent border-collapse">
                    <thead>
                    <tr>
                        <th
                            className={
                                "px-4 capitalize align-middle border-gray-500 border-solid  py-3 text-xs uppercase  whitespace-nowrap font-semibold text-center   "

                            }
                        >
                            Egreso
                        </th>
                        <th
                            className={
                                "px-4 capitalize align-middle border-gray-500 border-solid  py-3 text-xs uppercase  whitespace-nowrap font-semibold text-center   "

                            }
                        >
                            Fecha
                        </th>

                        <th
                            className={
                                "px-4 capitalize align-middle border-gray-500 border-solid  py-3 text-xs uppercase  whitespace-nowrap font-semibold text-center   "

                            }
                        >
                            Concepto
                        </th>

                        <th
                            className={
                                "px-4 capitalize align-middle border-gray-500 border-solid  py-3 text-xs uppercase  whitespace-nowrap font-semibold text-center   "

                            }
                        >
                            Detalle
                        </th>
                        <th
                            className={
                                "px-4 capitalize align-middle border-gray-500 border-solid  py-3 text-xs uppercase  whitespace-nowrap font-semibold text-center   "

                            }
                        >
                            Abono
                        </th>


                        <th
                            className={
                                "px-4 capitalize align-middle border-gray-500 border-solid  py-3 text-xs uppercase  whitespace-nowrap font-semibold text-center   "

                            }
                        >
                            Saldo
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {(deducciones.length > 0) && deducciones.map((info, i) => {
                        return <tr key={i}>
                            <td className="border-t-0 td-item border-gray-500 border-solid px-6 texto-margin align-middle  text-xs whitespace-nowrap p-4 text-left items-center">
                                <span className="font-bold text-blueGray-600">
                                  {info.num_egreso ? info.num_egreso : ''}
                                </span>
                            </td>
                            <td className="border-t-0 td-item border-gray-500 border-solid px-6 texto-margin align-middle  text-xs whitespace-nowrap p-4 text-left items-center">
                                <span className=" font-bold text-blueGray-600">
                                  {info.anio_label} / {info.mes_label}
                                </span>
                            </td>


                            <td className="border-t-0 border concepto-item border-gray-500 border-solid px-6 texto-margin align-middle  text-xs whitespace-nowrap p-4 text-left items-center">
                                <span className="ml-3 font-bold text-blueGray-600">
                                  {info.descrip_abrev}
                                </span>
                            </td>

                            <td className="border-t-0 descripcion-item border-gray-500 border border-solid px-6 texto-margin align-middle  text-center overflow-hidden text-xs whitespace-nowrap p-4 items-center">
                                <span className="font-bold text-blueGray-600  text-justify">
                                  {info.nombre}
                                </span>
                            </td>

                            <td className="border-t-0 saldo-item border border-solid border-gray-500 px-6 texto-margin align-middle  text-xs whitespace-nowrap p-4 text-right items-center">
                                <span className=" font-bold text-blueGray-600">
                                  {convertirModena(info.valor)}
                                </span>
                            </td>
                            <td className="border-t-0 saldo-item border-gray-500 border-solid px-6 texto-margin align-middle  text-xs whitespace-nowrap p-4 text-right items-center">
                                <span className=" font-bold text-blueGray-600">
                                  {convertirModena(info.total)}
                                </span>
                            </td>
                        </tr>
                    })}
                    </tbody>
                </table>

                <div className="row">
                    <div className="totales" style={{marginLeft: "60%", marginTop: "15px", width: "100%" }} >
                        <ol type={"A"}>
                            <li>
                                <p>
                                    <span className=" uppercase font-semibold text-lg"> TOTAL DEDUCCIONES: </span> <span className="ml-2 font-semibold text-md">  {convertirModena(totalDed)} </span>
                                </p>
                            </li>
                        </ol>
                    </div>
                </div>

                <div className="mt-5 mb-4 cuenta row  py-3 border-gray-500 border-gray-500  border-solid " style={{width: "100%",}}>
                    <div className=" mt-2 cuenta-cont lg:w-6/12 px-4">
                        <div className="div-cuenta"><span className="font-semibold text-sm"> CUENTA: </span>  <span className="text-sm">{`${dataCenta.descripcion} - ${dataCenta.num_cuenta} - ${dataCenta.tipocuenta}` }</span></div>
                        <div className="gran-container"><span className=" uppercase font-semibold gran-total"> TOTAL PAGADO: </span> <span className="ml-2 font-semibold gran-total">  {convertirModena(ingreso - totalDed)} </span></div>
                    </div>
                </div>

                <div className="row">
                    <div style={{marginLeft: "60%", marginTop: "15px" }} >
                        <ol type={"A"}>
                            <li>
                                <p>
                                    <span className=" uppercase font-semibold text-xl esconder"> TOTAL PAGADO: </span> <span className="ml-2 font-semibold text-xl esconder">  {convertirModena(ingreso - totalDed)} </span>
                                </p>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>

        </div>
    );
};

PagoDeduccion.prototype = {
    datapago: PropTypes.array,
    prestaciones: PropTypes.array,
}

PagoDeduccion.defaultProps = {
    datapago: [],
    prestaciones: [],
}

